import { render, staticRenderFns } from "./psAccountSettlementApplyAction.vue?vue&type=template&id=1f736353&scoped=true"
import script from "./psAccountSettlementApplyAction.vue?vue&type=script&lang=js"
export * from "./psAccountSettlementApplyAction.vue?vue&type=script&lang=js"
import style0 from "./psAccountSettlementApplyAction.vue?vue&type=style&index=0&id=1f736353&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f736353",
  null
  
)

export default component.exports